import { IArea } from '../../../../interfaces/common/location';
import { BranchType } from '../../../../interfaces/delivery-company/branches';

export type BranchInput = Omit<BranchType, 'area'>  & {
  area: IArea | null
}

export const emptyBranch: BranchInput = {
  id: '',
  name: '',
  directions: '',
  area: null,
  is_default: false,
  letter: null,
};
